import { Empty as AntdEmpty } from "@empglabs/backoffice-ui-kit"

const Empty = props => {
  return <AntdEmpty {...props} />
}

export default Empty
